import classNames from 'classnames';
import React from 'react';
import clearIcon from '../../icons/non-prefilled/16x16/clear.svg';
import SVGIcon from '../SVGIcon';
import * as styles from './ToggleControl.module.scss';

export interface ToggleControlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  type: 'checkbox';
  error?: string;
  label?: React.ReactNode;
  disabled?: boolean;
}

const ToggleControl = ({
  error,
  label,
  disabled,
  ...inputProps
}: ToggleControlProps) => (
  <label className={classNames(styles.toggle, { [styles.error]: error })}>
    {!!label && <div className={styles.label}>{label}</div>}
    <input className={styles.input} disabled={disabled} {...inputProps} />
    <div className={classNames(styles.track, { [styles.disabled]: disabled })}>
      <div className={styles.knob}>
        {disabled && <SVGIcon size={10}>{clearIcon}</SVGIcon>}
      </div>
    </div>
  </label>
);

export default ToggleControl;
